import { HdeSchemas } from '@api/types/generated/apiSchemas';
import { OddsFinal } from '@api/types/oddsFinal';

type FinalDividend = HdeSchemas['FinalDividend'];

const adaptOddsFinal = (report: FinalDividend): OddsFinal => {
  const { data, racecourse, ...reportProps } = report;

  return {
    ...reportProps,
    racecourseCode: racecourse.code,
    data:
      data?.map(({ combination, ...datum }) => ({
        ...datum,
        combination,
      })) ?? [],
  };
};

export { adaptOddsFinal };
